import React, { useState } from 'react'
import ModelComponent from '../../../components/Modal'
import { ErrorMessage, Form, Formik } from 'formik'
import { Col, Row, Tab, ToggleButton } from 'react-bootstrap'
import TextError from '../../../components/TextError'
import * as Yup from 'yup'
import axiosProvider from '../../../lib/AxiosProvider'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import {
  encodedSearchText,
  fetchOrderData,
  showToast
} from '../../../lib/AllGlobalFunction'

const ConfirmOrder = ({
  modalShow,
  setModalShow,
  getOrderItems,
  setLoading,
  initialValues,
  setInitialValues,
  initVal,
  setToast,
  toast,
  filterDetails
}) => {
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()

  const validationSchema = Yup.object().shape({
    warehouseId: Yup.string().required('Please select warehouse')
  })

  const onSubmit = async (values) => {
    Swal.fire({
      title: 'Confirm Item',
      text: `Are you sure you want to confirm this item?`,
      icon: 'question',
      showCancelButton: _SwalDelete.showCancelButton,
      confirmButtonColor: _SwalDelete.confirmButtonColor,
      cancelButtonColor: _SwalDelete.cancelButtonColor,
      confirmButtonText: 'Yes, Confirm Item',
      cancelButtonText: 'No, Keep Reviewing'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true)

          const response = await axiosProvider({
            method: 'PUT',
            endpoint: 'ManageOrder/OrderConfirm',
            data: values,
            userId,
            location: location?.pathname
          })
          setLoading(false)
          if (response?.status === 200) {
            setModalShow({ show: false, type: '', data: null })
            const order = await fetchOrderData(
              `?searchText=${encodedSearchText(
                filterDetails?.searchText
              )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
                filterDetails?.pageSize
              }`,
              toast,
              setToast
            )

            if (order?.status === 200) {
              getOrderItems(values?.orderId, order?.data?.data)
            }

            showToast(toast, setToast, response)
          }
        } catch {
          setLoading(false)

          showToast(toast, setToast, {
            data: {
              message: _exception?.message,
              code: 204
            }
          })
        }
      }
    })
  }

  return (
    <ModelComponent
      show={modalShow?.show}
      modalsize={'lg'}
      modalheaderclass={''}
      className='modal-backdrop'
      modeltitle={'Order warehouse details'}
      onHide={() => {
        setInitialValues(initVal)
        setModalShow({ show: !modalShow?.show, data: null })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
      formbuttonid={'confirm'}
      submitname={'Confirm Item'}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues?.confirm}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form id='confirm'>
            <Tab.Container id='left-tabs-example' defaultActiveKey='first'>
              <Row>
                {modalShow?.data?.length > 0 &&
                  modalShow?.data?.map((data) => (
                    <Col md={4}>
                      <ToggleButton
                        key={data?.warehouseId}
                        className='mb-2'
                        id={data?.warehouseId}
                        checked={data?.warehouseId === values?.warehouseId}
                        type='checkbox'
                        name={data?.warehouseName}
                        variant='outline-primary'
                        onMouseDown={() => {
                          setFieldValue('warehouseId', data?.warehouseId)
                          setFieldValue(
                            'productWarehouseId',
                            data?.productWarehouseId ?? 0
                          )
                        }}
                      >
                        <div>
                          <span>{data?.warehouseName}</span>
                        </div>
                      </ToggleButton>
                    </Col>
                  ))}
                <ErrorMessage name='warehouseId' component={TextError} />
              </Row>
            </Tab.Container>{' '}
          </Form>
        )}
      </Formik>
    </ModelComponent>
  )
}

export default ConfirmOrder
